import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { useTranslation } from 'react-i18next';
import { LayoutBuilder } from '../components/Layouts';
import { SuccessContent } from '../components/Partials/SuccessContent/SuccessContent';

type SuccessPageProps = {
  pageConfig: GenericObject;
  message?: string;
  subtitle?: string;
  btnPrimaryLabel?: string;
};

const SuccessPage: FC<SuccessPageProps> = ({ pageConfig, message, subtitle, btnPrimaryLabel }) => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{pageConfig.title}</title>
      </Helmet>

      <LayoutBuilder layout={pageConfig.layout}>
        <SuccessContent
          message={message ?? t('successPage.defaultMessage')}
          subtitle={subtitle ?? t('successPage.defaultSubtitle')}
          btnPrimaryLabel={btnPrimaryLabel ?? t('successPage.primaryButton.defaultLabel')}
        />
      </LayoutBuilder>
    </>
  );
};

export { SuccessPage };

export default SuccessPage;
